/**
 * FundGenius HQ route selection: platform console vs agency owner workspace.
 */

import { isPlatformAdmin, isAgencyUser } from './portalAccess';
import {
  FUNDGENIUS_APP_CLIENTS_PATH,
  FUNDGENIUS_HQ_CLIENTS_PATH,
  isFundGeniusAppLoginHost,
} from './fundgeniusLoginBranding';

export function isFundGeniusPlatformClientsRoute(pathname = '') {
  return String(pathname || '').startsWith('/platform/fundgenius-hq');
}

export function isFundGeniusAgencyClientsRoute(pathname = '') {
  const path = String(pathname || '');
  return path.startsWith('/fundgenius-hq') || path.includes('/fundgenius-hq/clients');
}

/**
 * Platform admins use /platform/fundgenius-hq/clients (agency picker).
 * FundGenius agency owners use /fundgenius-hq/clients (their own agency).
 */
export function getFundGeniusClientsPathForUser(user, { hostname } = {}) {
  if (user && isPlatformAdmin(user)) {
    return FUNDGENIUS_HQ_CLIENTS_PATH;
  }
  if (user && isAgencyUser(user)) {
    return FUNDGENIUS_APP_CLIENTS_PATH;
  }
  if (isFundGeniusAppLoginHost(hostname)) {
    return FUNDGENIUS_APP_CLIENTS_PATH;
  }
  return FUNDGENIUS_HQ_CLIENTS_PATH;
}

export function getFundGeniusClientsPathWithAgency(user, agencyId) {
  const base = getFundGeniusClientsPathForUser(user);
  if (isPlatformAdmin(user) && agencyId) {
    return `${FUNDGENIUS_HQ_CLIENTS_PATH}?agency_id=${encodeURIComponent(agencyId)}`;
  }
  return base;
}
